import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";

/*BootstrapTable anbd table Related*/

/*Loader */
import FadeIn from "react-fade-in";
/*animation*/
import Loader from "../../common/loader/Loader";
/*Inputs*/
/*Styles*/
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import "./PlayerSettings.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 10,
    height: 10,
  },
  label: {
    fontSize: 12,
    margin: 0,
  },
  button: {
    display: "block",
    marginTop: theme.spacing(2),
  },
  formControl: {
    minWidth: 120,
  },
}));

export default function PlayerSettings(props) {
  const classes = useStyles();
  const [period, setPeriod] = React.useState(["0"]);
  const [idLineType, setIdLineType] = React.useState(0);
  const [idAgent, setIdAgent] = React.useState(0);
  const [idBook, setIdBook] = useState(0);
  const [idOffice, setIdOffice] = React.useState(0);
  const [playerNotes, setPlayerNotes] = React.useState({});
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [isLoading, setIsLoading] = React.useState(true);
  // let IdPeriod = '0';

  const requestNotes = (IdPlayer) => {
    const url =
      process.env.REACT_APP_API2_URL +
      "/Player/Player_GetNotes?idPlayer=" +
      IdPlayer;
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    })
      .then((response) => response.data)
      .then((response) => {
        console.log("PROPS====== PlayerNotes THEN", response);
        setPlayerNotes(response ?? {});
        setIsLoading(false);
      });
  };

  

  useEffect(() => {
    let IdPlayer = props.Player.idPlayer;
    requestNotes(IdPlayer);
  }, [props.Player.idPlayer]);

  /*Loader*/
  /**/

  const UpdateNotes = () => {
    console.log('hola');
    if(props.isBulk) return;

    let RequestDTO = {
      IdPlayer: props.Player.idPlayer,
      Notes0: playerNotes.notes0 == undefined ? '' : playerNotes.notes0,
      Notes1: playerNotes.notes1 == undefined ? '' : playerNotes.notes1,
      Notes2: playerNotes.notes2 == undefined ? '' : playerNotes.notes2,
      Notes3: playerNotes.notes3 == undefined ? '' : playerNotes.notes3,
      Notes4: playerNotes.notes4 == undefined ? '' : playerNotes.notes4,
      Notes5: playerNotes.notes5 == undefined ? '' : playerNotes.notes5,
      Notes6: playerNotes.notes6 == undefined ? '' : playerNotes.notes6,
    };
    console.log('RequestDTO',RequestDTO);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/PlayerNotesMaintenance",
      data: RequestDTO,
    })
      .then((response) => response.data)
      .then((response) => {
        if (response.data === 0) {
          alert("Data Successfully Updated");
        }
        console.log("response", response);

        requestNotes(playerNotes.idPlayer);
      });
  };

  const UpdateNotesBulk = () => {
    let RequestDTO = {
      IdPlayer: props.Player.idPlayer,
      Notes0: playerNotes.notes0 == undefined ? '' : playerNotes.notes0,
      Notes1: playerNotes.notes1 == undefined ? '' : playerNotes.notes1,
      Notes2: playerNotes.notes2 == undefined ? '' : playerNotes.notes2,
      Notes3: playerNotes.notes3 == undefined ? '' : playerNotes.notes3,
      Notes4: playerNotes.notes4 == undefined ? '' : playerNotes.notes4,
      Notes5: playerNotes.notes5 == undefined ? '' : playerNotes.notes5,
      Notes6: playerNotes.notes6 == undefined ? '' : playerNotes.notes6,
    };
    console.log('RequestDTO',RequestDTO);
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/Player/PlayerNotesMaintenanceBulk",
      data: RequestDTO,
    })
      .then((response) => response.data)
      .then((response) => {
        if (response.data === 0) {
          alert("Data Successfully Updated");
        }
        console.log("response", response);

        requestNotes(playerNotes.idPlayer);
      });
  };

  const handleNotesChange = (event, key, value) => {
    setPlayerNotes({
      ...playerNotes,
      [key]: event ? event.target.value : value,
    });

     if (props.isBulk) {
      props.onNotesChange({
        ...playerNotes,
        [key]: event ? event.target.value : value,
      });
    }
  };

  useEffect(() => {
    setLocalPlayer(props.Player);
  }, [props.Player]);

  const handleUpdate = (event, key, value) => {
    props.Player[key] = event ? event.target.value : value;
  };

  const BULK_FIELDS = ["EnableSports", "EnableCasino", "EnableHorses", "EnableCards", "ShowInTicker"];

  const [indet, setIndet] = React.useState({});

  useEffect(() => {
    if (props.isBulk) {
      const init = {};
      BULK_FIELDS.forEach(f => { init[f] = true; }); 
      setIndet(init);
    } else {
      setIndet({}); 
    }
  }, [props.isBulk]);

  const handleCheck = (field) => {
    if (indet?.[field]) {
      setIndet(prev => ({ ...prev, [field]: false }));
    }
  };

  const isIndeterminate = (field) => !!(props.isBulk && indet?.[field]);

  const [localPlayer, setLocalPlayer] = useState(props.Player);
  const handleChange = (event, key, value) => {
    setLocalPlayer({
      ...localPlayer,
      [key]: event ? event.target.value : value,
    });
  };

  useEffect(() => {
    setLocalPlayer(props.Player);
  }, [props.Player]);

  if (!localPlayer || !requestNotes) return <></>;
  return (
    <React.Fragment>
      <div class="flex flex-col gap-4">
        {isLoading ? (
          <FadeIn>
            <div class="d-flex justify-content-center align-items-center">
              <Loader height={360} width={360} />
            </div>
          </FadeIn>
        ) : (
          <>
            <div className="grid grid-cols-4 gap-4">
              <div className="!gap-0 vertical-options">
                <h3>Games</h3>
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localPlayer.enableSports}
                      indeterminate={isIndeterminate("EnableSports")}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "enableSports",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "enableSports",
                          event.target.checked
                        );
                        handleCheck("EnableSports");
                      }}
                      color="primary"
                    />
                  }
                  label="Enable Sports"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localPlayer.enableCasino}
                      indeterminate={isIndeterminate("EnableCasino")}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "enableCasino",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "enableCasino",
                          event.target.checked
                        );
                        handleCheck("EnableCasino");
                      }}
                      color="primary"
                    />
                  }
                  label="Enable Casino"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localPlayer.enableHorses}
                      indeterminate={isIndeterminate("EnableHorses")}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "enableHorses",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "enableHorses",
                          event.target.checked
                        );
                        handleCheck("EnableHorses");
                      }}
                      color="primary"
                    />
                  }
                  label="Enable Horses"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localPlayer.enableCards}
                      indeterminate={isIndeterminate("EnableCards")}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "enableCards",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "enableCards",
                          event.target.checked
                        );
                        handleCheck("EnableCards");
                      }}
                      color="primary"
                    />
                  }
                  label="Enable Cards"
                />
              </div>
              <div className="!gap-0 vertical-options">
                <h3>Hockey Line</h3>
                <FormControl component="fieldset">
                  <RadioGroup
                    label
                    value={localPlayer.nhlLine}
                    onChange={(event) => {
                      handleChange(event, "nhlLine");
                      handleUpdate(event, "nhlLine");
                    }}
                  >
                    <FormControlLabel
                      control={<Radio value="A" size="small" color="primary" />}
                      label="American"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value="C" size="small" color="primary" />}
                      label="Canadian"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="!gap-0 vertical-options">
                <h3>Baseball Line</h3>
                <FormControl component="fieldset">
                  <RadioGroup
                    label
                    value={localPlayer.mlbLine}
                    onChange={(event) => {
                      handleChange(event, "mlbLine");
                      handleUpdate(event, "mlbLine");
                    }}
                  >
                    <FormControlLabel
                      control={<Radio value="N" size="small" color="primary" />}
                      label="Normal"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value="W" size="small" color="primary" />}
                      label="Wide"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value="Y" size="small" color="primary" />}
                      label="Eastern"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
              <div className="!gap-0 vertical-options">
                <h3>Pitcher Default</h3>
                <FormControl component="fieldset">
                  <RadioGroup
                    label
                    value={localPlayer.pitcherDefault}
                    onChange={(event) => {
                      handleChange(event, "pitcherDefault");
                      handleUpdate(event, "pitcherDefault");
                    }}
                  >
                    <FormControlLabel
                      control={<Radio value={0} size="small" color="primary" />}
                      label="Action"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value={1} size="small" color="primary" />}
                      label="Visitor"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value={2} size="small" color="primary" />}
                      label="Home"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value={3} size="small" color="primary" />}
                      label="Listed"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      control={<Radio value={4} size="small" color="primary" />}
                      label="Same"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            <div className="vertical-options">
              <div className="flex flex-row gap-4">
                <TextField
                  size="small"
                  type="text"
                  label="Line Style"
                  value={localPlayer.lineStyle}
                  onChange={(event) => handleChange(event, "lineStyle")}
                  // onBlur={(event) => handleUpdate(event, "lineStyle")}
                  disabled
                  variant="outlined"
                />
                <FormControlLabel
                  classes={{ label: classes.label }}
                  control={
                    <Checkbox
                      size="small"
                      checked={localPlayer.showInTicker}
                      indeterminate={isIndeterminate("ShowInTicker")}
                      onChange={(event) => {
                        handleChange(
                          undefined,
                          "showInTicker",
                          event.target.checked
                        );
                        handleUpdate(
                          undefined,
                          "showInTicker",
                          event.target.checked
                        );
                        handleCheck("ShowInTicker")
                      }}
                      color="primary"
                    />
                  }
                  label="Show Plays In Ticker"
                />
              </div>

              <div className="flex flex-row gap-4">
                <TextField
                  size="small"
                  type="text"
                  label="Timezone"
                  value={localPlayer.idTimeZone}
                  onChange={(event) => handleChange(event, "idTimeZone")}
                  // onBlur={(event) => handleUpdate(event, "idTimeZone")}
                  disabled
                  variant="outlined"
                />
                <TextField
                  size="small"
                  type="text"
                  label="Language"
                  value={localPlayer.idLanguage}
                  onChange={(event) => handleChange(event, "idLanguage")}
                  // onBlur={(event) => handleUpdate(event, "idLanguage")}
                  disabled
                  variant="outlined"
                />
              </div>
            </div>
            <div className="vertical-options">
              <h3>Secret</h3>
              <TextField
                size="small"
                type="text"
                label="Question"
                value={localPlayer.secQuestion}
                onChange={(event) => handleChange(event, "secQuestion")}
                onBlur={(event) => handleUpdate(event, "secQuestion")}
                variant="outlined"
              />
              <TextField
                size="small"
                type="text"
                label="Answer"
                value={localPlayer.secAnswer}
                onChange={(event) => handleChange(event, "secAnswer")}
                onBlur={(event) => handleUpdate(event, "secAnswer")}
                variant="outlined"
              />
            </div>

            <div className="vertical-options">
              <h3>Notes</h3>

              <TextField
                className="flex-1"
                size="small"
                type="text"
                label="Marketing Notes"
                value={playerNotes.notes1}
                onChange={(event) => handleNotesChange(event, "notes1")}
                onBlur={(event) => UpdateNotes()}
                variant="outlined"
                multiline
                minRows={4}
              />
              <TextField
                className="flex-1"
                size="small"
                type="text"
                label="Customer Service Notes"
                value={playerNotes.notes4}
                onChange={(event) => handleNotesChange(event, "notes4")}
                onBlur={(event) => UpdateNotes()}
                variant="outlined"
                multiline
                minRows={4}
              />
            </div>
          </>
        )}
      </div>
    </React.Fragment>
  );
}
